<div fxLayout="row" fxLayoutAlign="center center" class="mb-52">
    <div fxFlex="50">
        <lib-activate-totp
                (loggedInProfile)="onLogin($event)"
                (msg)="onMsg($event)"
                (errorMsg)="onError($event)">
        </lib-activate-totp>
    </div>
</div>